<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="storm-clouds">
<p style="margin-top: 250px;">“The real 1960s began on the afternoon of November 22, 1963. Kennedy’s murder opened some malign trap door in American culture, and wild bats flapped out.”</p><br/>
<p style="text-align: right;">Author Lance Morrow</p>
<p style="text-align: right;">Time Magazine</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?63bcc494